import { EntGovernment } from './handBooks/government'
import { EntRoleAvailableRoutes } from './rolesAvailableRoutes'

export class EntRole {
	id: number = 0
	alias: string = ''
	nameRu: string = ''
	nameKy: string = ''
	governmentIds?: number[] | null = null
	governments: EntGovernment[] | null = null
	passwordLength?: number | null = null
	availableRoutes?: EntRoleAvailableRoutes[] | null = null
	// deleted: boolean = false;
}
